import { filter, finalize, take } from 'rxjs';
import { ref, computed } from 'vue';
import { ErrorCode } from '@golden/gdk-base';
import { useWatchObservable } from './useWatchObservable';
export const maintainErrorCodes = [
    ErrorCode.PM_MAINTENANCE,
    ErrorCode.PLAYER_MAINTENANCE
];
export const authErrorCodes = [
    ErrorCode.UNAUTHENTICATED,
    ErrorCode.TOKEN_EXPIRED,
    ErrorCode.TOKEN_INVALID,
    ErrorCode.IP_MISS_MATCH,
    ErrorCode.NOT_LOGINABLE,
    ErrorCode.RETRY_LOGIN
];
// eslint-disable-next-line @typescript-eslint/no-empty-function
let onAuthError = () => { };
let isOnAuthError = false;
let alert = null;
let toast = null;
export let useDefaultGDKErrorHandler = useGDKErrorAlert;
export function registerAuthError(callback) {
    onAuthError = callback;
}
export function registerGDKAlert(callback) {
    alert = callback;
}
export function registerGDKToast(callback) {
    toast = callback;
}
export function registerDefaultGDKErrorHandler(callback) {
    useDefaultGDKErrorHandler = callback(authErrorCodes);
}
export function useGDKErrorAlert(handler, options) {
    return (error) => {
        if (!('lang' in error)) {
            console.error(error);
        }
        if (!alert)
            throw new Error('need register alert');
        if (maintainErrorCodes.includes(error.code))
            return;
        if (authErrorCodes.includes(error.code)) {
            if (isOnAuthError)
                return;
            isOnAuthError = true;
        }
        if (error.code === ErrorCode.CLIENT_NETWORK_ERROR) {
            // 特例：如果錯誤是網路斷線導致，轉為顯示 toast
            useGDKErrorToast(handler)(error);
            return;
        }
        void alert(error.message, {
            ...options
        }).then(() => {
            if (authErrorCodes.includes(error.code)) {
                onAuthError();
                isOnAuthError = false;
            }
            if (handler)
                handler(error);
        });
    };
}
export function useGDKErrorToast(handler, options) {
    return (error) => {
        if (!('lang' in error)) {
            console.error(error);
        }
        if (!toast)
            throw new Error('need register toast');
        if (maintainErrorCodes.includes(error.code))
            return;
        if (authErrorCodes.includes(error.code)) {
            if (isOnAuthError)
                return;
            isOnAuthError = true;
        }
        void toast(error.message, options ?? {}).then(() => {
            if (authErrorCodes.includes(error.code)) {
                if (authErrorCodes.includes(error.code)) {
                    onAuthError();
                    isOnAuthError = false;
                }
            }
            if (handler)
                handler(error);
        });
    };
}
export function useGDKFetch(actionName, validate, obs, 
// eslint-disable-next-line @typescript-eslint/no-empty-function
next = () => { }, error = useDefaultGDKErrorHandler()) {
    const loading = ref(false);
    const start = (done) => {
        if (loading.value || !validate.value)
            return;
        loading.value = true;
        obs().pipe(finalize(() => {
            loading.value = false;
            if (done && done instanceof Function)
                done();
        })).subscribe({
            next,
            error
        });
    };
    const disabled = computed(() => !validate.value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        loading,
        disabled,
        [actionName]: start
    };
}
export function onFetchLoaded(loading, done) {
    useWatchObservable(loading).pipe(filter((data) => !data.newVal), take(1)).subscribe(() => done());
}
//# sourceMappingURL=useGDKFetch.js.map